import definitions from "../../../definitions";
import EnemyCrab from "../../actor/enemy/EnemyCrab";
import MinigameChickenRun from "./MinigameChickenRun";

export default class MinigameCrabCatch extends MinigameChickenRun {
    /**
     * @param {string} id
     * @param {string} owner
     */
    constructor(id, owner) {
        super(id, owner);
    }

    /**
     * @param {object} metadata
     */
    init(metadata) {
        super.init(metadata);
    }

    /**
     * @param {GameScene} game
     */
    spawnChicken(game) {
        const position = game.world.findSafePosition({x:this._pen.x + (this._pen.width/2), y:this._pen.y + (this._pen.height/2)}, 200, 180, 20, [], 10);
        const chicken = game.createEnemy(this._chickenType, position, false, false);
        chicken.target = game.player;
        chicken.state = definitions.ENEMY_STATE.RETREAT;
        chicken.signals.grabbed.add(this.onChickenGrabbed, this);
        
        this._allChickens.push(chicken);
    }

    /**
     * @param {Enemy} enemy
     */
    onChickenGrabbed(chicken) {
        if (this._holdingChicken != null || chicken.state != definitions.ENEMY_STATE.RETREAT)
            return;

        if (chicken instanceof EnemyCrab) {
            P3.audio.playSound("sfx_crab_catch_00");
            this._holdingChickenSfx = P3.audio.playSound("sfx_crab_hold_loop_00", {loop: true});
        }
            
        //chicken.interactable = false;
        this._holdingChicken = chicken;
        chicken.state = definitions.ENEMY_STATE.CAPTURE;
        this._holdingChicken.collisionEnabled = this._holdingChicken.collisionDynamic = false;
        this._player.holdingObject = true;
        this._holdingChicken.view.x = this._player.holdingOffset.x - 10;
        this._holdingChicken.view.y = this._player.holdingOffset.y + 5;
        
        this._player.addChild(this._holdingChicken.view);
        this._player.addChild(this._player.view);

        super.onChickenGrabbed(chicken);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameStart(game) {
        super.onMinigameStart(game);

        let currentEnemyCrabsInWorld = game.findEnemies(definitions.ENEMY_ID.CRAB_HOSTILE);
        for (let i = 0; i < currentEnemyCrabsInWorld.length; ++i) {
            const enemyCrab = currentEnemyCrabsInWorld[i];
            enemyCrab.enabled = false;
            enemyCrab.view.visible = false;
        }
    }

    /**
     * @param {GameScene} game
     */
    onMinigameUpdate(game) {
        if (this.isRunning) {
            const chickenCount = this._allChickens.length;
            if (chickenCount < this._spawnLimit) {
                if (this._spawnTime > this._spawnDelay) {
                    this._spawnTime = 0;
                    this.spawnChicken(game);
                }
                this._spawnTime += window.dt;
            }
            if(game.player.testCollisionRectFastOld(this._deposit.x, this._deposit.y, this._deposit.width, this._deposit.height)){
                if(this._holdingChicken){
                    this._holdingChicken.state = definitions.ENEMY_STATE.IDLE;
                    this._holdingChicken.position = game.world.findSafePosition({x:this._pen.x + (this._pen.width/2), y:this._pen.y + (this._pen.height/2)}, 0, Math.min(this._pen.width, this._pen.height)/2);
                    this._holdingChicken.facingDirection = Math.random() > 0.5 ? 1 : -1;
                    this._holdingChicken.view.position.set(0);
                    this._holdingChicken.addChild(this._holdingChicken.view);
                    this._holdingChicken = null;
                    
                    P3.audio.playSound("sfx_crab_release_00");
                    this._holdingChickenSfx && this._holdingChickenSfx.stop();

                    this._player.holdingObject = false;
                    this.score++;
                    if(this.score >= chickenCount){
                        game.completeMinigame(true)
                    }
                }
            }
        }
        super.onMinigameUpdate(game);
    }

    /**
     * @param {GameScene} game
     */
    onMinigameEnd(game) {
        super.onMinigameEnd(game);

        let currentEnemyCrabsInWorld = game.findEnemies(definitions.ENEMY_ID.CRAB_HOSTILE);
        for (let i = 0; i < currentEnemyCrabsInWorld.length; ++i) {
            const enemyCrab = currentEnemyCrabsInWorld[i];
            enemyCrab.enabled = true;
            enemyCrab.view.visible = true;
        }
    }

    onMinigameCancel(game) {
        super.onMinigameCancel(game);
        
        let currentEnemyCrabsInWorld = game.findEnemies(definitions.ENEMY_ID.CRAB_HOSTILE);
        for (let i = 0; i < currentEnemyCrabsInWorld.length; ++i) {
            const enemyCrab = currentEnemyCrabsInWorld[i];
            enemyCrab.enabled = true;
            enemyCrab.view.visible = true;
        }
    }
}